// Default minumun value of max Y Axis domain
export const DEFAULT_MIN_MAX_Y_AXIS_DOMAIN = 10;

// Minumin of data length to display horizontal scroll bar (slider)
export const MIN_BRUSH_DATA_LENGTH = 12;
